import { createFileRoute } from '@tanstack/react-router'

import { dayQuery, historyQuery } from '../../lib/queries'
import { HistoryDay } from '../../screens/HistoryDay'

export const Route = createFileRoute('/history/$date')({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(dayQuery(params.date)),
      context.queryClient.ensureQueryData(historyQuery(params.date, params.date)),
    ]),
  component: HistoryDay,
})
